import React, { useState } from 'react';
import { 
  Box, Card, CardContent, Grid, Typography, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, Paper, Chip, Button, Dialog, 
  DialogTitle, DialogContent, DialogActions, TextField, Select, MenuItem,
  FormControl, InputLabel, Switch, FormControlLabel, Tabs, Tab
} from '@mui/material';
import { 
  Add, Edit, Spa, FitnessCenter, SelfImprovement, LocalDrink,
  Whatshot, Psychology, Timer, CalendarMonth, TrendingUp, AttachMoney, Insights
} from '@mui/icons-material';
import { useThemeMode } from '../context/ThemeContext';

// Datos simulados de recompensas Caldea
const mockRewards = [
  {
    id: 1,
    name: 'Sesión Descontracturante Post-Entreno',
    category: 'RECOVERY',
    triggerType: 'CARDIO_SESSION',
    triggerThreshold: '3km carrera o 20min cardio',
    improvementCost: 15,
    quota: 20,
    quotaUsed: 12,
    valleyHours: '10:00-14:00',
    status: 'ACTIVE',
    description: 'Primera sesión de descarga muscular tras entrenamiento cardiovascular intenso'
  },
  {
    id: 2,
    name: 'Upgrade Circuito Recovery',
    category: 'RECOVERY',
    triggerType: 'STRENGTH_SESSION',
    triggerThreshold: '45min fuerza',
    improvementCost: 20,
    quota: 15,
    quotaUsed: 8,
    valleyHours: '11:00-15:00',
    status: 'ACTIVE',
    description: 'Acceso a sauna, relax y baños de contraste post entrenamiento de fuerza'
  },
  {
    id: 3,
    name: 'Breathwork Guiado (15min)',
    category: 'EMOTIONAL',
    triggerType: 'HIGH_STRESS',
    triggerThreshold: 'HRV bajo detectado',
    improvementCost: 10,
    quota: 30,
    quotaUsed: 22,
    valleyHours: 'Todo el día',
    status: 'ACTIVE',
    description: 'Sesión de respiración guiada en zona relax para gestión del estrés'
  },
  {
    id: 4,
    name: 'Hidratación Saludable',
    category: 'WELLNESS',
    triggerType: 'WEEKLY_STREAK',
    triggerThreshold: '3 visitas/semana',
    improvementCost: 5,
    quota: 100,
    quotaUsed: 45,
    valleyHours: 'Todo el día',
    status: 'ACTIVE',
    description: 'Infusión o bebida baja en azúcar de la carta wellness'
  },
  {
    id: 5,
    name: 'Sesión Movilidad Guiada',
    category: 'RECOVERY',
    triggerType: 'STRENGTH_SESSION',
    triggerThreshold: '60min entrenamiento',
    improvementCost: 12,
    quota: 25,
    quotaUsed: 18,
    valleyHours: '09:00-12:00',
    status: 'ACTIVE',
    description: 'Estiramiento y movilidad articular post-entreno con instructor'
  },
  {
    id: 6,
    name: 'Quiet Hour Premium',
    category: 'EMOTIONAL',
    triggerType: 'MONTHLY_GOAL',
    triggerThreshold: '12 sesiones/mes',
    improvementCost: 30,
    quota: 10,
    quotaUsed: 3,
    valleyHours: '14:00-16:00',
    status: 'ACTIVE',
    description: 'Hora exclusiva en zona relax con aromaterapia'
  }
];

// Datos de canjes recientes
const recentRedemptions = [
  // Enero 2026
  { id: 1, user: 'Maria G.', reward: 'Sesión Descontracturante', date: '2026-01-27 10:30', trigger: 'Cardio 5.2km' },
  { id: 2, user: 'Carlos P.', reward: 'Breathwork Guiado', date: '2026-01-27 09:15', trigger: 'HRV 42ms' },
  { id: 3, user: 'Ana L.', reward: 'Hidratación Saludable', date: '2026-01-26 18:00', trigger: 'Racha 3 días' },
  { id: 4, user: 'Pedro M.', reward: 'Upgrade Circuito Recovery', date: '2026-01-26 12:30', trigger: 'Fuerza 55min' },
  { id: 5, user: 'Laura S.', reward: 'Sesión Movilidad', date: '2026-01-26 11:00', trigger: 'Entreno 65min' },
  { id: 6, user: 'Jordi T.', reward: 'Quiet Hour Premium', date: '2026-01-25 15:20', trigger: 'Meta mensual 12 sesiones' },
  { id: 7, user: 'Sofia R.', reward: 'Breathwork Guiado', date: '2026-01-24 19:10', trigger: 'HRV 38ms' },
  { id: 8, user: 'Marc D.', reward: 'Hidratación Saludable', date: '2026-01-24 13:05', trigger: 'Racha 4 días' },
  { id: 9, user: 'Lucia F.', reward: 'Sesión Movilidad', date: '2026-01-23 09:40', trigger: 'Entreno 60min' },
  { id: 10, user: 'Pablo C.', reward: 'Upgrade Circuito Recovery', date: '2026-01-22 17:30', trigger: 'Fuerza 50min' },

  // Diciembre 2025
  { id: 11, user: 'Nuria V.', reward: 'Sesión Descontracturante', date: '2025-12-29 10:10', trigger: 'Cardio 4.8km' },
  { id: 12, user: 'Albert G.', reward: 'Breathwork Guiado', date: '2025-12-28 08:55', trigger: 'HRV 40ms' },
  { id: 13, user: 'Claudia M.', reward: 'Hidratación Saludable', date: '2025-12-28 16:20', trigger: 'Racha 3 días' },
  { id: 14, user: 'David S.', reward: 'Sesión Movilidad', date: '2025-12-27 11:30', trigger: 'Entreno 62min' },
  { id: 15, user: 'Irene K.', reward: 'Upgrade Circuito Recovery', date: '2025-12-27 12:50', trigger: 'Fuerza 58min' },
  { id: 16, user: 'Ramon P.', reward: 'Quiet Hour Premium', date: '2025-12-26 15:00', trigger: 'Meta mensual 12 sesiones' },
  { id: 17, user: 'Marta L.', reward: 'Breathwork Guiado', date: '2025-12-24 19:25', trigger: 'HRV 41ms' },
  { id: 18, user: 'Oscar J.', reward: 'Hidratación Saludable', date: '2025-12-24 12:40', trigger: 'Racha 3 días' },
  { id: 19, user: 'Eva R.', reward: 'Sesión Movilidad', date: '2025-12-23 10:05', trigger: 'Entreno 64min' },
  { id: 20, user: 'Guillem N.', reward: 'Upgrade Circuito Recovery', date: '2025-12-22 18:15', trigger: 'Fuerza 52min' },

  // Noviembre 2025
  { id: 21, user: 'Paula A.', reward: 'Sesión Descontracturante', date: '2025-11-29 09:50', trigger: 'Cardio 5.0km' },
  { id: 22, user: 'Sergi B.', reward: 'Breathwork Guiado', date: '2025-11-28 08:40', trigger: 'HRV 39ms' },
  { id: 23, user: 'Helena C.', reward: 'Hidratación Saludable', date: '2025-11-28 17:15', trigger: 'Racha 3 días' },
  { id: 24, user: 'Arnau F.', reward: 'Sesión Movilidad', date: '2025-11-27 10:55', trigger: 'Entreno 61min' },
  { id: 25, user: 'Laia P.', reward: 'Upgrade Circuito Recovery', date: '2025-11-27 13:10', trigger: 'Fuerza 57min' },
  { id: 26, user: 'Xavi R.', reward: 'Quiet Hour Premium', date: '2025-11-26 14:40', trigger: 'Meta mensual 12 sesiones' },
  { id: 27, user: 'Neus D.', reward: 'Breathwork Guiado', date: '2025-11-25 18:35', trigger: 'HRV 43ms' },
  { id: 28, user: 'Pol T.', reward: 'Hidratación Saludable', date: '2025-11-25 12:10', trigger: 'Racha 4 días' },
  { id: 29, user: 'Aina V.', reward: 'Sesión Movilidad', date: '2025-11-24 09:20', trigger: 'Entreno 60min' },
  { id: 30, user: 'Oriol M.', reward: 'Upgrade Circuito Recovery', date: '2025-11-23 17:45', trigger: 'Fuerza 53min' },
];

// Performance de rewards y segmentos (BI)
const rewardPerformance = [
  { name: 'Thermal Premium', redemptions: 128, revenue: '€4.8k', margin: '61%', occupancyLift: '+9%' },
  { name: 'Family Pack', redemptions: 94, revenue: '€3.1k', margin: '54%', occupancyLift: '+6%' },
  { name: 'Après‑Ski Relax', redemptions: 76, revenue: '€2.9k', margin: '58%', occupancyLift: '+8%' },
  { name: 'Breathwork Guiado', redemptions: 142, revenue: '€1.1k', margin: '66%', occupancyLift: '+3%' },
];

const segmentImpact = [
  { segment: 'Premium', uplift: '+12.4%', bestWindow: '18:00–20:00', channel: 'Push + Email' },
  { segment: 'Familias', uplift: '+8.1%', bestWindow: '19:00–21:00', channel: 'Push' },
  { segment: 'Wellness Ocasional', uplift: '+6.7%', bestWindow: '12:00–13:30', channel: 'Email' },
  { segment: 'Turista Esquí', uplift: '+9.2%', bestWindow: '16:30–18:00', channel: 'SMS + Push' },
];

const categoryColors = {
  RECOVERY: { bg: 'rgba(14,165,233,0.1)', color: '#0284c7', icon: Spa },
  EMOTIONAL: { bg: 'rgba(168,85,247,0.1)', color: '#9333ea', icon: Psychology },
  WELLNESS: { bg: 'rgba(34,197,94,0.1)', color: '#16a34a', icon: LocalDrink }
};

const triggerIcons = {
  CARDIO_SESSION: FitnessCenter,
  STRENGTH_SESSION: Whatshot,
  HIGH_STRESS: SelfImprovement,
  WEEKLY_STREAK: CalendarMonth,
  MONTHLY_GOAL: Timer
};

export default function RewardsPage() {
  const [tabValue, setTabValue] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const { isDark, colors } = useThemeMode();
  
  // Theme-aware colors
  const themeColors = {
    cardBg: isDark ? '#1e293b' : '#ffffff',
    cardBorder: isDark ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)',
    textPrimary: isDark ? '#f1f5f9' : '#1e293b',
    textSecondary: isDark ? '#94a3b8' : '#64748b',
    chipBg: isDark ? 'rgba(29,202,255,0.2)' : 'rgba(29,202,255,0.1)',
    tableBg: isDark ? '#0f172a' : '#f8fafc',
  };

  const getCategoryChip = (category) => {
    const config = categoryColors[category];
    const Icon = config.icon;
    return (
      <Chip 
        icon={<Icon sx={{ color: `${config.color} !important`, fontSize: 16 }} />}
        label={category} 
        size="small"
        sx={{ 
          backgroundColor: isDark ? `${config.color}30` : config.bg, 
          color: config.color,
          fontWeight: 600 
        }} 
      />
    );
  };

  const getQuotaStatus = (quota, used) => {
    const remaining = quota - used;
    const percentage = (used / quota) * 100;
    let color = 'success';
    if (percentage > 80) color = 'error';
    else if (percentage > 60) color = 'warning';
    
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2">{remaining}/{quota}</Typography>
        <Box sx={{ 
          width: 60, height: 6, backgroundColor: '#e0e0e0', borderRadius: 3,
          overflow: 'hidden'
        }}>
          <Box sx={{ 
            width: `${percentage}%`, 
            height: '100%', 
            backgroundColor: color === 'success' ? '#22c55e' : color === 'warning' ? '#f97316' : '#ef4444',
            borderRadius: 3
          }} />
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, color: '#0f172a', fontSize: '1.75rem', mb: 0.5 }}>
            Catálogo de Recompensas
          </Typography>
          <Typography variant="body2" sx={{ color: '#64748b' }}>
            Caldea Club × PEpL — Recovery Rewards & Wellness
          </Typography>
        </Box>
        <Button 
          variant="contained" 
          startIcon={<Add />} 
          onClick={() => setOpenDialog(true)}
          sx={{ 
            background: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)',
            boxShadow: '0 4px 14px rgba(14,165,233,0.35)',
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            px: 3
          }}
        >
          Nueva Recompensa
        </Button>
      </Box>

      {/* KPIs Summary */}
      <Grid container spacing={2} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            borderRadius: 3, 
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            transition: 'all 0.2s ease',
            '&:hover': { boxShadow: '0 8px 24px rgba(0,0,0,0.08)', transform: 'translateY(-2px)' }
          }}>
            <CardContent sx={{ p: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, bgcolor: 'rgba(14,165,233,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Spa sx={{ color: '#0284c7', fontSize: 20 }} />
                </Box>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e293b', fontSize: '1.75rem' }}>3</Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.8rem', mb: 0.5 }}>Recovery Rewards</Typography>
              <Typography variant="caption" sx={{ color: '#22c55e', fontWeight: 500 }}>+2 esta semana</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            borderRadius: 3, 
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            transition: 'all 0.2s ease',
            '&:hover': { boxShadow: '0 8px 24px rgba(0,0,0,0.08)', transform: 'translateY(-2px)' }
          }}>
            <CardContent sx={{ p: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, bgcolor: 'rgba(168,85,247,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Psychology sx={{ color: '#9333ea', fontSize: 20 }} />
                </Box>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e293b', fontSize: '1.75rem' }}>2</Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.8rem', mb: 0.5 }}>Wellness Emocional</Typography>
              <Typography variant="caption" sx={{ color: '#94a3b8' }}>Breathwork + Quiet Hour</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            borderRadius: 3, 
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            transition: 'all 0.2s ease',
            '&:hover': { boxShadow: '0 8px 24px rgba(0,0,0,0.08)', transform: 'translateY(-2px)' }
          }}>
            <CardContent sx={{ p: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, bgcolor: 'rgba(34,197,94,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <TrendingUp sx={{ color: '#16a34a', fontSize: 20 }} />
                </Box>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e293b', fontSize: '1.75rem' }}>28</Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.8rem', mb: 0.5 }}>Canjes Hoy</Typography>
              <Typography variant="caption" sx={{ color: '#22c55e', fontWeight: 500 }}>↑ 15% vs ayer</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ 
            borderRadius: 3, 
            border: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
            transition: 'all 0.2s ease',
            '&:hover': { boxShadow: '0 8px 24px rgba(0,0,0,0.08)', transform: 'translateY(-2px)' }
          }}>
            <CardContent sx={{ p: 2.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
                <Box sx={{ width: 40, height: 40, borderRadius: 2, bgcolor: 'rgba(249,115,22,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Insights sx={{ color: '#ea580c', fontSize: 20 }} />
                </Box>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700, color: '#1e293b', fontSize: '1.75rem' }}>92</Typography>
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.8rem', mb: 0.5 }}>Cupo Disponible</Typography>
              <Typography variant="caption" sx={{ color: '#94a3b8' }}>de 200 total</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tabs */}
      <Box sx={{ 
        borderBottom: 1, 
        borderColor: 'rgba(0,0,0,0.08)', 
        mb: 3,
        '& .MuiTab-root': {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.9rem',
          color: '#64748b',
          '&.Mui-selected': { color: '#0f172a', fontWeight: 600 }
        },
        '& .MuiTabs-indicator': { backgroundColor: '#0ea5e9', height: 3, borderRadius: '3px 3px 0 0' }
      }}>
        <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)}>
          <Tab label="Catálogo de Rewards" />
          <Tab label="Canjes Recientes" />
          <Tab label="Reglas de Negocio" />
        </Tabs>
      </Box>

      {/* Tab Content */}
      {tabValue === 0 && (
        <Card sx={{ 
          borderRadius: 3, 
          border: '1px solid rgba(0,0,0,0.06)',
          boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
          overflow: 'hidden'
        }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#fafbfc' }}>
                  <TableCell sx={{ fontWeight: 600, color: '#64748b', fontSize: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>Recompensa</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#64748b', fontSize: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>Categoría</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#64748b', fontSize: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>Trigger</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#64748b', fontSize: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>Nivel Mejora</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#64748b', fontSize: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>Cupo Disp.</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#64748b', fontSize: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>Horario Valle</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#64748b', fontSize: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>Estado</TableCell>
                  <TableCell sx={{ fontWeight: 600, color: '#64748b', fontSize: '0.75rem', borderBottom: '1px solid #e2e8f0' }}>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {mockRewards.map((reward) => {
                  const TriggerIcon = triggerIcons[reward.triggerType] || FitnessCenter;
                  return (
                    <TableRow key={reward.id} hover sx={{ '&:hover': { bgcolor: 'rgba(0,0,0,0.02)' } }}>
                      <TableCell sx={{ borderBottom: '1px solid #f1f5f9' }}>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 600, color: '#1e293b', fontSize: '0.85rem' }}>{reward.name}</Typography>
                          <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.75rem' }}>{reward.description}</Typography>
                        </Box>
                    </TableCell>
                    <TableCell>{getCategoryChip(reward.category)}</TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TriggerIcon fontSize="small" color="action" />
                        <Typography variant="body2">{reward.triggerThreshold}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip label={`Nivel ${reward.improvementCost}`} size="small" sx={{ fontWeight: 600 }} />
                    </TableCell>
                    <TableCell>{getQuotaStatus(reward.quota, reward.quotaUsed)}</TableCell>
                    <TableCell>
                      <Chip label={reward.valleyHours} size="small" variant="outlined" />
                    </TableCell>
                    <TableCell>
                      <Chip 
                        label={reward.status} 
                        size="small" 
                        color={reward.status === 'ACTIVE' ? 'success' : 'default'} 
                      />
                    </TableCell>
                    <TableCell>
                      <Button size="small" startIcon={<Edit />}>Editar</Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        </Card>
      )}

      {tabValue === 1 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
              <TableRow>
                <TableCell><strong>Usuario</strong></TableCell>
                <TableCell><strong>Recompensa</strong></TableCell>
                <TableCell><strong>Trigger Activado</strong></TableCell>
                <TableCell><strong>Fecha/Hora</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {recentRedemptions.map((redemption) => (
                <TableRow key={redemption.id} hover>
                  <TableCell>{redemption.user}</TableCell>
                  <TableCell>{redemption.reward}</TableCell>
                  <TableCell>
                    <Chip label={redemption.trigger} size="small" variant="outlined" color="primary" />
                  </TableCell>
                  <TableCell>{redemption.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {tabValue === 2 && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  ✅ Policy (Reglas de Negocio)
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Typography variant="body2">• <strong>Cardio intenso</strong> → Descarga muscular</Typography>
                  <Typography variant="body2">• <strong>Fuerza/Volumen</strong> → Movilidad articular</Typography>
                  <Typography variant="body2">• <strong>HRV bajo (estrés)</strong> → Breathwork/Relax</Typography>
                  <Typography variant="body2">• <strong>Racha semanal</strong> → Recompensa adherencia</Typography>
                  <Typography variant="body2">• <strong>Meta mensual</strong> → Premium benefits</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  🛡️ Guardrails (Protección)
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Typography variant="body2">• <strong>Lista blanca</strong>: Solo categorías healthy</Typography>
                  <Typography variant="body2">• <strong>Bloqueo</strong>: Alcohol y recompensas incoherentes</Typography>
                  <Typography variant="body2">• <strong>Límites</strong>: Max 2 canjes/día por usuario</Typography>
                  <Typography variant="body2">• <strong>Cupos</strong>: Protección de capacidad operativa</Typography>
                  <Typography variant="body2">• <strong>Horarios valle</strong>: Mejora yield del spa</Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}


      {/* Dialog Nueva Recompensa */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Nueva Recompensa Caldea</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField fullWidth label="Nombre de la Recompensa" />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Categoría</InputLabel>
                <Select defaultValue="RECOVERY" label="Categoría">
                  <MenuItem value="RECOVERY">Recovery (Spa)</MenuItem>
                  <MenuItem value="EMOTIONAL">Bienestar Emocional</MenuItem>
                  <MenuItem value="WELLNESS">Wellness General</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel>Tipo de Trigger</InputLabel>
                <Select defaultValue="CARDIO_SESSION" label="Tipo de Trigger">
                  <MenuItem value="CARDIO_SESSION">Sesión Cardio</MenuItem>
                  <MenuItem value="STRENGTH_SESSION">Sesión Fuerza</MenuItem>
                  <MenuItem value="HIGH_STRESS">Estrés Alto (HRV)</MenuItem>
                  <MenuItem value="WEEKLY_STREAK">Racha Semanal</MenuItem>
                  <MenuItem value="MONTHLY_GOAL">Meta Mensual</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Nivel Requerido" type="number" defaultValue={10} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Cupo Diario" type="number" defaultValue={20} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Horario Valle" defaultValue="10:00-14:00" />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={2} label="Descripción" />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancelar</Button>
          <Button variant="contained" sx={{ backgroundColor: '#00A9CE' }}>Guardar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
